import {IThemeIcons} from '../../architecture/sections/theme-icons.interface';
import {AddIcon} from './icons/add.icon';
import {MrGreenExclusivesIcon} from './icons/side-menu/green-exclusives.icon';
import {ScratchCardsIcon} from './icons/side-menu/scratch-cards.icon';
import {NewGamesIcon} from './icons/side-menu/new-games.icon';
import {CasinoGamesIcon} from './icons/side-menu/casino-games.icon';
import {ControlCenterIcon} from './icons/navbar-right-container/control-center.icon';
import {MrGreenLiveExclusiveIcon} from "./icons/live-arena-navbar/mrgreen-live-exclusive.icon";
import {AppHeaderCasinoIcon} from "./icons/header-navbar/app-header-casino.icon";
import {BlogIcon} from './icons/side-menu/blog.icon';
import {VipIcon} from './icons/side-menu/vip.icon';
import {AppHeaderPokerIcon} from "./icons/header-navbar/app-header-poker.icon";
import {SportFootballIcon} from "../../defaults/icons/side-menu/sport-football.icon";

export const MrGreenIcons: Partial<IThemeIcons> = {
    addIcon: AddIcon,
    appHeaderSportIcon: SportFootballIcon,
    appHeaderCasinoIcon: AppHeaderCasinoIcon,
    appHeaderPokerIcon: AppHeaderPokerIcon,
    sideMenuBlog: BlogIcon,
    sideMenuExclusive888: MrGreenExclusivesIcon,
    sideMenuScratchCards: ScratchCardsIcon,
    sideMenuNewGames: NewGamesIcon,
    sideMenuCasinoGames: CasinoGamesIcon,
    sideMenuVip: VipIcon,
    controlCenterIcon: ControlCenterIcon,
    tripleEightExclusiveIcon: MrGreenLiveExclusiveIcon

};

